import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import './QuizBlasterGame.css';

const QuizBlasterGame = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const iframeRef = useRef(null);
  const containerRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const enterFullscreen = async () => {
    try {
      if (containerRef.current) {
        if (containerRef.current.requestFullscreen) {
          await containerRef.current.requestFullscreen();
        } else if (containerRef.current.webkitRequestFullscreen) {
          await containerRef.current.webkitRequestFullscreen();
        }
      }
    } catch (error) {
      console.log('Fullscreen not available:', error);
    }
  };

  const exitFullscreen = async () => {
    try {
      if (document.exitFullscreen) {
        await document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        await document.webkitExitFullscreen();
      }
    } catch (error) {
      console.log('Exit fullscreen error:', error);
    }
  };

  const handleFullscreenChange = () => {
    setIsFullscreen(
      document.fullscreenElement || document.webkitFullscreenElement
    );
  };

  const sendQuizToIframe = () => {
    const quizId = searchParams.get('quizId');
    if (quizId && iframeRef.current) {
      const db = localStorage.getItem('quizBlasterDatabase');
      const quizzes = db ? JSON.parse(db) : [];
      const quiz = quizzes.find(q => q.id === quizId);
      
      if (quiz) {
        console.log('📤 Sending quiz to iframe:', quiz.title);
        iframeRef.current.contentWindow.postMessage({
          type: 'loadQuiz',
          quiz: quiz
        }, '*');
      }
    }
  };

  const handleIframeLoad = () => {
    console.log('🎮 Quiz Blaster iframe loaded');
    // Send backend URL to iframe for global game submissions
    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage({
        type: 'setBackendUrl',
        url: process.env.REACT_APP_BACKEND_URL
      }, '*');
    }
    // Send quiz data after iframe is fully loaded
    setTimeout(sendQuizToIframe, 500);
    // Also send again after a bit more time for safety
    setTimeout(sendQuizToIframe, 1500);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      enterFullscreen();
    }, 500);

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
    };
  }, []);

  const handleExit = async () => {
    await exitFullscreen();
    setTimeout(() => {
      navigate('/quiz-blaster-hub');
    }, 300);
  };

  return (
    <div ref={containerRef} className="quiz-blaster-game-page">
      {isFullscreen && (
        <div className="game-controls">
          <Button onClick={handleExit} className="exit-btn">
            <ArrowLeft size={18} />
            Exit Game
          </Button>
        </div>
      )}
      
      {!isFullscreen && (
        <div className="game-header">
          <Button onClick={handleExit} className="back-btn" variant="ghost">
            <ArrowLeft size={20} />
            Back to Quiz Blaster Hub
          </Button>
        </div>
      )}

      <iframe
        ref={iframeRef}
        src="/quiz-blaster.html"
        className="game-iframe"
        title="Quiz Blaster Game"
        allow="fullscreen"
        onLoad={handleIframeLoad}
      />
    </div>
  );
};

export default QuizBlasterGame;
